import React, { useRef } from "react";

//const DEFAULT_SPORTS = ["NBA"];
const DEFAULT_SPORTS = ["NBA","CBB","MLB", "NHL", "SOCCER", "NFL", "CFB", "MMA","WNBA","TEG","MSI","FPA", "EURO"];

export default function SportsMenu({ activeSport, onSportChange, sports = DEFAULT_SPORTS, availability = {} }) {
  const btnRefs = useRef([]);

  const onKeyDown = (e, idx) => {
    if (e.key !== "ArrowRight" && e.key !== "ArrowLeft") return;
    e.preventDefault();
    const dir = e.key === "ArrowRight" ? 1 : -1;
    const next = (idx + dir + sports.length) % sports.length;
    btnRefs.current[next]?.focus();
  };

  return (
    <nav className="sport-rail__container" aria-label="Sports">
      <div className="sport-rail__scroller" role="tablist" aria-orientation="horizontal">
        {sports.map((s, i) => {
          const status = availability[s] || {};
          const disabled = status.disabled === true;
          return (
          <button
            key={s}
            ref={(el) => (btnRefs.current[i] = el)}
            type="button"
            role="tab"
            aria-selected={activeSport === s}
            className={`sport-pill ${activeSport === s ? "is-active" : ""}`}
            onClick={() => !disabled && onSportChange?.(s)}
            onKeyDown={(e) => onKeyDown(e, i)}
            disabled={disabled}
            title={disabled ? status.message : undefined}
          >
            {s}
          </button>
          );
        })}
      </div>
    </nav>
  );
}
